export default function parseRangeDate(value) {
    var parts = value.split('-');
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1;
    var day = parseInt(parts[2], 10);

    return new Date(year, month, day);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/cldr/parse-range-date.js
// module id = 1616
// module chunks = 30